
import "./dashboardPushButton.css";
import LinearProgressWithLabel from './LinearProgressWithLabel.tsx';
import TouchAppIcon from '@mui/icons-material/TouchApp';

const DashboardPushButton = () => {
    return (
        <div className='dashboardPushButtonMainContainer'>
            <div style={{marginLeft:"-7px"}} className='dashboardPushButtonTopContainer'>
                    <span >< TouchAppIcon id='touchIconImg' /></span>
                <p className='EnvDataHeading'>Push Button</p>
            </div>
            <div className='dashboardPushButtonBottomContainer'>
                <div className="dashboardPushButtonInfoTopContainer">
                    <p className='Temperature' style={{ marginBottom: "8px" }}>Battery Percentage</p>
                </div>
                <div className="dashboardPushButtonInfoBottomContainer">
                    <p className='BatteryInfo'>30%</p>
                    {/* <div className='BatteryBarBox' ></div> */}
                  <div style={{width:"100%"}}>
                  <LinearProgressWithLabel value={30}  />
                  </div>
                </div>
            </div>
        </div>
    )
}

export default DashboardPushButton;